import React, {useState, useEffect} from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

export default function ComboBox({ options, handleOnChange, title, initialValue }) {
    const [value, setValue] = useState(initialValue)
    useEffect(() => {
        setValue(initialValue)
    }, [initialValue])
  return (
    <Autocomplete
        id="combo-box-demo"
        options={options}
        getOptionLabel={(option) => option?.name || ""}
        style={{ width: 300 }}
        value={value}
        onChange={(e, v) => {
            setValue(v)
            handleOnChange(v)
          }
        }
      renderInput={(params) => 
            <TextField 
                    {...params}
                    label={title}
                    variant="outlined"
            />
        }
    />
  );
}
